import { POPULAR_SERVICES } from './servicesData';
import categoryCatalog from './categoryServicesCatalog.json';

const normalizeText = (value) => String(value || '').trim().toLowerCase();

const formatINR = (value) => {
  const amount = Number(value || 0);
  return `\u20B9${amount.toLocaleString('en-IN')}`;
};

const toNumericPrice = (value) => {
  if (typeof value === 'number') {
    return value;
  }
  const parsed = parseInt(String(value || '').replace(/[^\d]/g, ''), 10);
  return Number.isFinite(parsed) ? parsed : 0;
};

const cloneServices = (services = []) => {
  return (services || []).map((service) => ({
    ...service,
    features: Array.isArray(service.features) ? [...service.features] : []
  }));
};

const mapPopularToCategoryService = (service, nextId) => ({
  id: nextId,
  title: service.name,
  price: formatINR(toNumericPrice(service.price)),
  duration: service.duration || '1-2 hours',
  description: service.description || '',
  features: Array.isArray(service.features) ? service.features : [],
  image: service.image || service.icon || 'Om',
  rating: Number(service.rating || 0),
  reviews: Number(service.reviewCount || service.reviews || 0)
});

const mergePopularServices = (targetServices, matcher) => {
  const existingTitles = new Set(targetServices.map((item) => normalizeText(item.title)));
  let nextId = targetServices.reduce((max, item) => Math.max(max, Number(item.id) || 0), 0) + 1;

  POPULAR_SERVICES
    .filter((service) => matcher(normalizeText(`${service.name} ${service.category}`)))
    .forEach((service) => {
      const title = normalizeText(service.name);
      if (existingTitles.has(title)) {
        return;
      }
      targetServices.push(mapPopularToCategoryService(service, nextId));
      existingTitles.add(title);
      nextId += 1;
    });
};

const categoryServices = categoryCatalog?.categoryServices || {};

export const WEDDING_SERVICES = cloneServices(categoryServices.wedding);
export const HOME_POOJA_SERVICES = cloneServices(categoryServices.homePooja);
export const FESTIVAL_SERVICES = cloneServices(categoryServices.festival);
export const LIFE_EVENTS_SERVICES = cloneServices(categoryServices.lifeEvents);
export const SPIRITUAL_SERVICES = cloneServices(categoryServices.spiritual);
export const SPECIAL_OCCASIONS_SERVICES = cloneServices(categoryServices.specialOccasions);

mergePopularServices(WEDDING_SERVICES, (text) => /marriage|wedding|engagement|ring|mehendi/.test(text));
mergePopularServices(HOME_POOJA_SERVICES, (text) => /griha|vastu|ganpati|lakshmi|home/.test(text));
mergePopularServices(SPIRITUAL_SERVICES, (text) => /satyanarayan|rudra|katha|chalisa|spiritual|religious/.test(text));

export const SERVICE_FILTERS = categoryCatalog?.serviceFilters || {};
export const PAGE_CONFIGS = categoryCatalog?.pageConfigs || {};

const FILTER_TAGS = categoryCatalog?.filterTags || {};
const TAG_INFERENCE_RULES = categoryCatalog?.tagInferenceRules || {};

const inferServiceTags = (serviceType, service) => {
  const explicitTags = Array.isArray(service?.tags) ? service.tags : [];
  if (explicitTags.length > 0) {
    return explicitTags;
  }

  const rules = TAG_INFERENCE_RULES[serviceType] || [];
  const haystack = normalizeText(`${service?.title || ''} ${service?.description || ''}`);
  const inferred = rules
    .filter((rule) => new RegExp(rule.pattern || '', 'i').test(haystack))
    .map((rule) => rule.tag)
    .filter(Boolean);

  return inferred.length > 0 ? inferred : ['all'];
};

export const getFilteredServices = (serviceType, filterId, services) => {
  if (filterId === 'all') return services;

  const requestedTags = FILTER_TAGS?.[serviceType]?.[filterId] || [];
  if (requestedTags.length === 0) {
    return services;
  }

  return services.filter((service) => {
    const serviceTags = inferServiceTags(serviceType, service);
    return requestedTags.some((tag) => serviceTags.includes(tag));
  });
};
